import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import App from './App';
import router from './router';
import store from './store';
import Toaster from 'v-toaster';
import VeeValidate, { Validator } from 'vee-validate';
import vi from 'vee-validate/dist/locale/vi';
Validator.localize('vi', vi);

import vSelect from 'vue-select';
import { formatDatetime, format12Hours, formatDate } from './filters/datetime';
import VueI18n from 'vue-i18n';
import viMessage from './lang/vi.json';
import enMessage from './lang/en.json';
import * as L from 'leaflet';
import './utils/leaflet-location.min.js';
import './utils/leaflet-location.min.css';
import './utils/leaflet-measure.css';
import './utils/leaflet-measure.en.js';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';

import 'leaflet.featuregroup.subgroup';

import {
    LMap,
    LTileLayer,
    LMarker,
    LControlZoom,
    LIcon,
    LTooltip,
    LGeoJson,
    LControl,
    LControlLayers,
    LPopup
} from 'vue2-leaflet';
import VueApexCharts from 'vue-apexcharts';
import 'leaflet/dist/leaflet.css';
import { VueEditor } from 'vue2-editor';

// For Leaflet Icon
import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.use(VueApexCharts);
Vue.use(VueEditor);
Vue.use(L);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Toaster, { timeout: 2000 });
Vue.use(VeeValidate, { fieldsBagName: 'veeFields', locale: 'vi' });
Vue.use(require('vue-moment'));
Vue.use(VueI18n);

const messages = {
    vi: viMessage,
    en: enMessage
};
export const i18n = new VueI18n({
    locale: 'vi',
    messages,
    fallbackLocale: 'vi'
});

Vue.component('v-select', vSelect);
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-popup', LPopup);
Vue.component('l-control-zoom', LControlZoom);
Vue.component('l-icon', LIcon);
Vue.component('l-control', LControl);
Vue.component('l-tooltip', LTooltip);
Vue.component('l-geo-json', LGeoJson);
Vue.component('l-control-layers', LControlLayers);
Vue.component('apex-chart', VueApexCharts);
Vue.component('vue2-editor', VueEditor);

Vue.filter('formatDateTime', formatDatetime);
Vue.filter('formatDate', formatDate);
Vue.filter('format12Hours', format12Hours);

Vue.directive('click-outside', {
    bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
            const compName = vNode.context.name;
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
            if (compName) {
                warn += `Found in component '${compName}'`;
            }

            console.warn(warn);
        }
        // Define Handler and cache it on the element
        const handler = e => {
            if (!el.contains(e.target) && el !== e.target) {
                binding.value(e);
            }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
    },

    unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
    }
});

new Vue({
    el: '#app',
    i18n,
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
});
